import React , {Component} from 'react';
import './Documentation.css'


class Documentation  extends Component {

  state = {
    logged_in:false,
    api_key: "",
  }

  tryAPI = (api_endpoint , url) => {

        let final_api_url = api_endpoint + url
        window.open(final_api_url, "_blank")
  }

  render(){
    let api_endpoint = "https://vims.cis.udel.edu/geography/seaice/services/";
    const theme_color ={
      color : '#15f4ee',
      fontSize : '1.7em',
    }
    return(
      <div className = "margin">
      <div className = "api-overview">
        <h1>API OVERVIEW</h1>
        <p>
          Welcome to version 1 of The Ice Database API.
          Our API is available for everyone to use. As always, you must attribute VIMS lab as the source of your data.
        </p>
        <h1>API DOCUMENTATION</h1>
          <p>
            Below you will find a current list of the available methods on our Arctic Expedition.
          </p>
      </div>
          <div className = "api">
            <h1> API ENDPOINT </h1>
              {api_endpoint}

          <h1>API METHODS</h1>

          <h2> <span style = {theme_color}>GET</span>/getskq2015images/</h2>

            <h6>Definition</h6>
              <p>Get a list of all pair of streo images taken on SKQ2015 ship.</p>
            <h6> Response </h6>
            <table>
              <thead>
                <th> Field </th>
                <th> Description </th>
              </thead>
              <tbody>
                <tr>
                  <td> ship </td>
                  <td> Name of the ship </td>
                </tr>
                <tr>
                  <td> year </td>
                  <td> Year of the expedition </td>
                </tr>
                <tr>
                  <td> month </td>
                  <td> Month of the expedition </td>
                </tr>
                <tr>
                  <td> day </td>
                  <td> Day of the expedition </td>
                </tr>
                <tr>
                  <td> hour </td>
                  <td> Hour of the expedition </td>
                </tr>
                <tr>
                  <td> minute </td>
                  <td> Minute of the expedition </td>
                </tr>
                <tr>
                  <td> seconds </td>
                  <td> Seconds of the expedition </td>
                </tr>
                <tr>
                  <td> stereo_id </td>
                  <td> Identification number of the captured stereo pair of images</td>
                </tr>
                <tr>
                  <td> left_image </td>
                  <td> URL to the left stereo image</td>
                </tr>
                <tr>
                  <td> left_image </td>
                  <td> URL to the right stereo image</td>
                </tr>
                <tr>
                  <td> page </td>
                  <td> Retrieves first 1000 results for specified page number.</td>
                </tr>
                <tr>
                  <td> key </td>
                  <td> API key provided at signup.</td>
                </tr>
              </tbody>
            </table>
            { this.state.logged_in?
              <button onClick = {() => this.tryAPI(api_endpoint , 'getskq2015images/page=1' + '&key=' + this.state.api_key)}>Try it yourself</button>:
              <button disabled = {!this.state.logged_in}> Login to try it yourself</button>
            }
          </div>
          <div className = "api">
            <h2><span style = {theme_color}>GET</span>/getoatrcimages/</h2>
            <h6>Definition</h6>
              <p>Get a list of all pair of streo images taken on OATRC ship</p>
            <h6> Responses </h6>
            <table>
              <thead>
                <th> Field </th>
                <th> Description </th>
              </thead>
              <tbody>
                <tr>
                  <td> ship </td>
                  <td> Name of the ship </td>
                </tr>
                <tr>
                  <td> year </td>
                  <td> Year of the expedition </td>
                </tr>
                <tr>
                  <td> month </td>
                  <td> Month of the expedition </td>
                </tr>
                <tr>
                  <td> day </td>
                  <td> Day of the expedition </td>
                </tr>
                <tr>
                  <td> hour </td>
                  <td> Hour of the expedition </td>
                </tr>
                <tr>
                  <td> minute </td>
                  <td> Minute of the expedition </td>
                </tr>
                <tr>
                  <td> seconds </td>
                  <td> Seconds of the expedition </td>
                </tr>
                <tr>
                  <td> stereo_id </td>
                  <td> Identification number of the captured stereo pair of images</td>
                </tr>
                <tr>
                  <td> left_image </td>
                  <td> URL to the left stereo image</td>
                </tr>
                <tr>
                  <td> left_image </td>
                  <td> URL to the right stereo image</td>
                </tr>
                <tr>
                  <td> page </td>
                  <td> Retrieves first 1000 results for specified page number.</td>
                </tr>
                <tr>
                  <td> key </td>
                  <td> API key provided at signup.</td>
                </tr>
              </tbody>
            </table>
            { this.state.logged_in?
              <button onClick = {() => this.tryAPI(api_endpoint , 'getoatrcimages/page=1' + '&key=' + this.state.api_key)}>Try it yourself</button>:
              <button disabled = {!this.state.logged_in}> Login to try it yourself</button>
            }
          </div>
          <div className = "api">
            <h2><span style = {theme_color}>GET</span>/getyear/</h2>
            <h6>Definition</h6>
              <p>Get a list of all years for which the ship had gone for the expedtion.</p>
              <h2>Query Parameters</h2>
              <table>
                <thead>
                  <th> Field</th>
                  <th> Description</th>
                </thead>
                <tbody>
                  <tr>
                    <td>ship</td>
                    <td>Name of the ship for whom the years are to be fetched  </td>
                  </tr>
                </tbody>
              </table>
            <h6> Responses </h6>
            <table>
              <thead>
                <th> Field </th>
                <th> Description </th>
              </thead>
              <tbody>
                <tr>
                  <td> year </td>
                  <td> Year of the expedition </td>
                </tr>
              </tbody>
            </table>
            { this.state.logged_in?
              <button onClick = {() => this.tryAPI(api_endpoint , 'getyear/ship=OATRC' + '&key=' + this.state.api_key)}>Try it yourself</button>:
              <button disabled = {!this.state.logged_in}> Login to try it yourself</button>
            }
          </div>
          <div className = "api">
            <h2><span style = {theme_color}>GET</span>/getmonth/</h2>
            <h6>Definition</h6>
              <p>Get a list all months for the selected year that the selected ship had gone for the expedtion</p>
              <h2>Query Parameters</h2>
              <table>
                <thead>
                  <th> Field</th>
                  <th> Description</th>
                </thead>
                <tbody>
                  <tr>
                    <td>ship</td>
                    <td>Name of the ship for whom the months are to be fetched  </td>
                  </tr>
                  <tr>
                    <td>year</td>
                    <td>Year of the expedition for whom the months are to be fetched  </td>
                  </tr>
                  <tr>
                    <td> key </td>
                    <td> API key provided at signup.</td>
                  </tr>
                </tbody>
              </table>
            <h6> Responses </h6>
            <table>
              <thead>
                <th> Field </th>
                <th> Description </th>
              </thead>
              <tbody>
                <tr>
                  <td> month </td>
                  <td> Months of the expedition </td>
                </tr>
              </tbody>
            </table>
            { this.state.logged_in?
              <button onClick = {() => this.tryAPI(api_endpoint , 'getmonth/ship=OATRC&year=2013' + '&key=' + this.state.api_key)}>Try it yourself</button>:
              <button disabled = {!this.state.logged_in}> Login to try it yourself</button>
            }
          </div>
          <div className = "api">
            <h2><span style = {theme_color}>GET</span>/getday/</h2>
            <h6>Definition</h6>
              <p>Get a list all days for the selected year and month that the selected ship had
              gone for the expedtion</p>
              <h2>Query Parameters</h2>
              <table>
                <thead>
                  <th> Field</th>
                  <th> Description</th>
                </thead>
                <tbody>
                  <tr>
                    <td>ship</td>
                    <td>Name of the ship for whom the days are to be fetched  </td>
                  </tr>
                  <tr>
                    <td>year</td>
                    <td>Year of the expedition for whom the days are to be fetched  </td>
                  </tr>
                  <tr>
                    <td>month</td>
                    <td>Month of the expedition for whom the day are to be fetched  </td>
                  </tr>
                  <tr>
                    <td> key </td>
                    <td> API key provided at signup.</td>
                  </tr>
                </tbody>
              </table>
            <h6> Responses </h6>
            <table>
              <thead>
                <th> Field </th>
                <th> Description </th>
              </thead>
              <tbody>
                <tr>
                  <td> days </td>
                  <td> Days of the expedition </td>
                </tr>
              </tbody>
            </table>
            { this.state.logged_in?
              <button onClick = {() => this.tryAPI(api_endpoint , 'getday/ship=OATRC&year=2013&month=8' + '&key=' + this.state.api_key)}>Try it yourself</button>:
              <button disabled = {!this.state.logged_in}> Login to try it yourself</button>
            }
          </div>
          <div className = "api">
            <h2><span style = {theme_color}>GET</span>/gethour/</h2>
            <h6>Definition</h6>
              <p>Get a list all hours for the selected year,month and day that the selected ship had
              gone for the expedtion</p>
              <h2>Query Parameters</h2>
              <table>
                <thead>
                  <th> Field</th>
                  <th> Description</th>
                </thead>
                <tbody>
                  <tr>
                    <td>ship</td>
                    <td>Name of the ship for whom the hours are to be fetched  </td>
                  </tr>
                  <tr>
                    <td>year</td>
                    <td>Year of the expedition for whom the hours are to be fetched  </td>
                  </tr>
                  <tr>
                    <td>month</td>
                    <td>Month of the expedition for whom the hours are to be fetched  </td>
                  </tr>
                  <tr>
                    <td>day</td>
                    <td>Day of the expedition for whom the hours are to be fetched</td>
                  </tr>
                  <tr>
                    <td> key </td>
                    <td> API key provided at signup.</td>
                  </tr>
                </tbody>
              </table>
            <h6> Responses </h6>
            <table>
              <thead>
                <th> Field </th>
                <th> Description </th>
              </thead>
              <tbody>
                <tr>
                  <td> hours </td>
                  <td> Hours of the expedition </td>
                </tr>
              </tbody>
            </table>
            { this.state.logged_in?
              <button onClick = {() => this.tryAPI(api_endpoint , 'gethour/ship=OATRC&year=2013&month=8&day=25' + '&key=' + this.state.api_key)}>Try it yourself</button>:
              <button disabled = {!this.state.logged_in}> Login to try it yourself</button>
            }
          </div>
          <div className = "api">
            <h2><span style = {theme_color}>GET</span>/getminute/</h2>
            <h6>Definition</h6>
              <p>Get a list all minutes for the selected year,month,day and hour that the selected ship had
              gone for the expedtion</p>
              <h2>Query Parameters</h2>
              <table>
                <thead>
                  <th> Field</th>
                  <th> Description</th>
                </thead>
                <tbody>
                  <tr>
                    <td>ship</td>
                    <td>Name of the ship for whom the minutes are to be fetched  </td>
                  </tr>
                  <tr>
                    <td>year</td>
                    <td>Year of the expedition for whom the minutes are to be fetched  </td>
                  </tr>
                  <tr>
                    <td>month</td>
                    <td>Month of the expedition for whom the minutes are to be fetched  </td>
                  </tr>
                  <tr>
                    <td>day</td>
                    <td>Day of the expedition for whom the minutes are to be fetched</td>
                  </tr>
                  <tr>
                    <td>hour</td>
                    <td>Hour of the expedition for whom the minutes are to be fetched</td>
                  </tr>
                  <tr>
                    <td> key </td>
                    <td> API key provided at signup.</td>
                  </tr>
                </tbody>
              </table>
            <h6> Responses </h6>
            <table>
              <thead>
                <th> Field </th>
                <th> Description </th>
              </thead>
              <tbody>
                <tr>
                  <td> minute </td>
                  <td> Minutes of the expedition </td>
                </tr>
              </tbody>
            </table>
            { this.state.logged_in?
              <button onClick = {() => this.tryAPI(api_endpoint , 'getminute/ship=OATRC&year=2013&month=8&day=25&hour=1' + '&key=' + this.state.api_key)}>Try it yourself</button>:
              <button disabled = {!this.state.logged_in}> Login to try it yourself</button>
            }
          </div>
          <div className = "api">
            <h2><span style = {theme_color}>GET</span>/getseconds/</h2>
            <h6>Definition</h6>
              <p>Get a list all seconds for the selected year, month, day, hour and minute that the selected ship had
              gone for the expedtion</p>
              <h2>Query Parameters</h2>
              <table>
                <thead>
                  <th> Field</th>
                  <th> Description</th>
                </thead>
                <tbody>
                  <tr>
                    <td>ship</td>
                    <td>Name of the ship for whom the seconds are to be fetched  </td>
                  </tr>
                  <tr>
                    <td>year</td>
                    <td>Year of the expedition for whom the seconds are to be fetched  </td>
                  </tr>
                  <tr>
                    <td>month</td>
                    <td>Month of the expedition for whom the seconds are to be fetched  </td>
                  </tr>
                  <tr>
                    <td>day</td>
                    <td>Day of the expedition for whom the seconds are to be fetched</td>
                  </tr>
                  <tr>
                    <td>hour</td>
                    <td>Hour of the expedition for whom the seconds are to be fetched</td>
                  </tr>
                  <tr>
                    <td>minute</td>
                    <td>Minute of the expedition for whom the seconds are to be fetched</td>
                  </tr>
                  <tr>
                    <td> key </td>
                    <td> API key provided at signup.</td>
                  </tr>
                </tbody>
              </table>
            <h6> Responses </h6>
            <table>
              <thead>
                <th> Field </th>
                <th> Description </th>
              </thead>
              <tbody>
                <tr>
                  <td> seconds </td>
                  <td> Seconds of the expedition </td>
                </tr>
              </tbody>
            </table>
            { this.state.logged_in?
              <button onClick = {() => this.tryAPI(api_endpoint , 'getsecond/ship=OATRC&year=2013&month=8&day=25&hour=1&minute=2' + '&key=' + this.state.api_key)}>Try it yourself</button>:
              <button disabled = {!this.state.logged_in}> Login to try it yourself</button>
            }
          </div>
          <div className = "api">
            <h2><span style = {theme_color}>GET</span>/getstereo/</h2>
            <h6>Definition</h6>
              <p>Get a list stereo ID for the selected year, month, day, hour, minute and seconds that the selected ship had
              gone for the expedtion</p>
              <h2>Query Parameters</h2>
              <table>
                <thead>
                  <th> Field</th>
                  <th> Description</th>
                </thead>
                <tbody>
                  <tr>
                    <td>ship</td>
                    <td>Name of the ship for whom the streo ID is to be fetched  </td>
                  </tr>
                  <tr>
                    <td>year</td>
                    <td>Year of the expedition for whom the streo ID is to be fetched  </td>
                  </tr>
                  <tr>
                    <td>month</td>
                    <td>Month of the expedition for whom the streo ID is to be fetched  </td>
                  </tr>
                  <tr>
                    <td>day</td>
                    <td>Day of the expedition for whom the streo ID is to be fetched</td>
                  </tr>
                  <tr>
                    <td>hour</td>
                    <td>Hour of the expedition for whom the streo ID is to be fetched</td>
                  </tr>
                  <tr>
                    <td>minute</td>
                    <td>Minute of the expedition for whom the streo ID is to be fetched</td>
                  </tr>
                  <tr>
                    <td>seconds</td>
                    <td>Seconds of the expedition for whom the the streo ID is to be fetched</td>
                  </tr>
                  <tr>
                    <td> key </td>
                    <td> API key provided at signup.</td>
                  </tr>
                </tbody>
              </table>
            <h6> Responses </h6>
            <table>
              <thead>
                <th> Field </th>
                <th> Description </th>
              </thead>
              <tbody>
                <tr>
                  <td> stereo_id </td>
                  <td> Stereo ID of the images to be retreived </td>
                </tr>
              </tbody>
            </table>
            { this.state.logged_in?
              <button onClick = {() => this.tryAPI(api_endpoint , 'getstereo/ship=OATRC&year=2013&month=8&day=25&hour=1&minute=2&seconds=0' + '&key=' + this.state.api_key)}>Try it yourself</button>:
              <button disabled = {!this.state.logged_in}> Login to try it yourself</button>
            }
          </div>
          <div className = "api">
            <h2><span style = {theme_color}>GET</span>/getleftimage/</h2>
            <h6>Definition</h6>
              <p>Get  the left image for the selected year, month, day, hour, minute, seconds and streo ID that the selected ship had
              gone for the expedtion</p>
              <h2>Query Parameters</h2>
              <table>
                <thead>
                  <th> Field</th>
                  <th> Description</th>
                </thead>
                <tbody>
                  <tr>
                    <td>ship</td>
                    <td>Name of the ship for whom the left image of the stereo pair is to be fetched  </td>
                  </tr>
                  <tr>
                    <td>year</td>
                    <td>Year of the expedition for whom the left image of the stereo pair is to be fetched  </td>
                  </tr>
                  <tr>
                    <td>month</td>
                    <td>Month of the expedition for whom the left image of the stereo pair is to be fetched  </td>
                  </tr>
                  <tr>
                    <td>day</td>
                    <td>Day of the expedition for whom the left image of the stereo pair is fetched</td>
                  </tr>
                  <tr>
                    <td>hour</td>
                    <td>Hour of the expedition for the left image of the stereo pair is to be fetched</td>
                  </tr>
                  <tr>
                    <td>minute</td>
                    <td>Minute of the expedition for whom the left image of the stereo pair is to be fetched</td>
                  </tr>
                  <tr>
                    <td>seconds</td>
                    <td>Seconds of the expedition for whom the left image of the stereo pair is to be fetched</td>
                  </tr>
                  <tr>
                    <td>seconds</td>
                    <td>Seconds of the expedition for whom the left image of the stereo pair is to be fetched</td>
                  </tr>
                  <tr>
                    <td>stereo_id</td>
                    <td>Stereo ID of the image for whom the left image of the stereo pair is to be fetched</td>
                  </tr>
                  <tr>
                    <td> key </td>
                    <td> API key provided at signup.</td>
                  </tr>
                </tbody>
              </table>
            <h6> Responses </h6>
            <table>
              <thead>
                <th> Field </th>
                <th> Description </th>
              </thead>
              <tbody>
                <tr>
                  <td> left_image_id </td>
                  <td> ID of the left image of the stereo pair </td>
                </tr>
              </tbody>
            </table>
            { this.state.logged_in?
              <button onClick = {() => this.tryAPI(api_endpoint , 'getleftimage/ship=OATRC&year=2013&month=8&day=25&hour=1&minute=2&seconds=0&stereo_id=358705' + '&key=' + this.state.api_key)}>Try it yourself</button>:
              <button disabled = {!this.state.logged_in}> Login to try it yourself</button>
            }
          </div>
          <div className = "api">
            <h2><span style = {theme_color}>GET</span>/getrightimage/</h2>
            <h6>Definition</h6>
              <p>Get  the right image for the selected year, month, day, hour, minute, seconds and streo ID that the selected ship had
              gone for the expedtion</p>
              <h2>Query Parameters</h2>
              <table>
                <thead>
                  <th> Field</th>
                  <th> Description</th>
                </thead>
                <tbody>
                  <tr>
                    <td>ship</td>
                    <td>Name of the ship for whom the right image of the stereo pair is to be fetched  </td>
                  </tr>
                  <tr>
                    <td>year</td>
                    <td>Year of the expedition for whom the right image of the stereo pair is to be fetched  </td>
                  </tr>
                  <tr>
                    <td>month</td>
                    <td>Month of the expedition for whom the right image of the stereo pair is to be fetched  </td>
                  </tr>
                  <tr>
                    <td>day</td>
                    <td>Day of the expedition for whom the right image of the stereo pair is fetched</td>
                  </tr>
                  <tr>
                    <td>hour</td>
                    <td>Hour of the expedition for the right image of the stereo pair is to be fetched</td>
                  </tr>
                  <tr>
                    <td>minute</td>
                    <td>Minute of the expedition for whom the right image of the stereo pair is to be fetched</td>
                  </tr>
                  <tr>
                    <td>seconds</td>
                    <td>Seconds of the expedition for whom the right image of the stereo pair is to be fetched</td>
                  </tr>
                  <tr>
                    <td>seconds</td>
                    <td>Seconds of the expedition for whom the right image of the stereo pair is to be fetched</td>
                  </tr>
                  <tr>
                    <td>stereo_id</td>
                    <td>Stereo ID of the image for whom the right image of the stereo pair is to be fetched</td>
                  </tr>
                  <tr>
                    <td> key </td>
                    <td> API key provided at signup.</td>
                  </tr>
                </tbody>
              </table>
            <h6> Responses </h6>
            <table>
              <thead>
                <th> Field </th>
                <th> Description </th>
              </thead>
              <tbody>
                <tr>
                  <td> right_image_id </td>
                  <td> ID of the left image of the stereo pair </td>
                </tr>
              </tbody>
            </table>
            { this.state.logged_in?
              <button onClick = {() => this.tryAPI(api_endpoint , 'getrightimage/ship=OATRC&year=2013&month=8&day=25&hour=1&minute=2&seconds=0&stereo_id=358705' + '&key=' + this.state.api_key)}>Try it yourself</button>:
              <button disabled = {!this.state.logged_in}> Login to try it yourself</button>
            }
          </div>

      <div className = "api">
        <h2><span style = {theme_color}>GET</span>/dwnldimg/</h2>
        <h6>Definition</h6>
          <p>Download sea ice raster image by its left or right image ID</p>
          <h2>Query Parameters</h2>
          <table>
            <thead>
              <th> Field</th>
              <th> Description</th>
            </thead>
            <tbody>
              <tr>
                <td> ship </td>
                <td> Name of the ship for whom the years are to be fetched </td>
              </tr>
              <tr>
                <td>img_id</td>
                <td>ID of the image to be downloaded  </td>
              </tr>
              <tr>
                <td> key </td>
                <td> API key provided at signup.</td>
              </tr>
            </tbody>
          </table>
        { this.state.logged_in?
          <button onClick = {() => this.tryAPI(api_endpoint , 'dwnldimg/' + 'ship=OATRC&img_id=20130821132636-cam12010990-0-0-52279.jpg' + '&key=' + this.state.api_key)}>Try it yourself</button>:
          <button disabled = {!this.state.logged_in}> Login to try it yourself</button>
        }
      </div>
      </div>
    )
  }

  componentDidMount(){
    let logged_in = JSON.parse(localStorage.getItem('logged_in'));
    let api_key = localStorage.getItem('api_key')
    console.log(logged_in)
    if (logged_in){
      this.setState({
        logged_in: logged_in,
        api_key:api_key
      })
    }else{
      this.setState({
        logged_in: logged_in,
        api_key:"",
      })
    }
  }
}

export default Documentation;



// WEBPACK FOOTER //
// ./src/components/Documentation/Documentation.js